import React from 'react';
import { ButtonV2, TextV2 } from '@withjoy/joykit';
import { Wrapper, Information, IconWrapper, CTAButton } from './ValueProposition.styles';

export const ValueProposition: React.FC<{ title?: string; description?: string; onClick?: () => void; path?: string; icon: React.ReactNode; ctaText: string }> = ({
  title,
  description,
  ctaText,
  onClick,
  path = '#',
  icon
}) => {
  return (
    <Wrapper onClick={onClick} to={path}>
      <IconWrapper>{icon}</IconWrapper>
      <Information>
        <TextV2 typographyVariant="label3">{title}</TextV2>
        <TextV2 typographyVariant="label2">{description}</TextV2>
      </Information>
      <CTAButton>
        <ButtonV2
          color="mono14"
          borderColor="mono14"
          variant={'outline'}
          intent="neutral"
          borderRadius={20}
          size={'md'}
          _hover={{ color: 'mono14' }}
          _active={{ color: 'mono14' }}
          fontWeight="semibold"
          fontSize={16}
        >
          {ctaText}
        </ButtonV2>
      </CTAButton>
    </Wrapper>
  );
};
